export const registerType = [
    "Registered business name",
    "Incorporated company",
    "Incorporated trustee",
    "Government entity"
  ];